import { formatErrorMessage } from "../../../../../services/axios/APIError";
import flash from "../../../../../services/flash";

/** Flash a Route Builder API failure using backend validation messages when present. */
export function flashRouteBuilderError(err: unknown, fallbackPrefix: string) {
  void flash.error(formatErrorMessage(err, fallbackPrefix));
}
